import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import routes from '@/config/routes';
import { fixHyphens } from '@/helpers';
import { Button, PanelLabel } from '@/components/common';

const ResetPasswordExpired = (): React.ReactElement => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleResendEmail = () => {
    history.push(routes.auth.resetPassword);
  };

  const handleBackToLogin = () => {
    history.push(routes.auth.login);
  };

  return (
    <>
      <PanelLabel>{t`auth.labelPasswordResetExpired`}</PanelLabel>
      <Message>{t`auth.resetLinkExpired`}</Message>

      <ButtonsContainer>
        <ButtonResendEmail
          color="primary"
          size="l"
          onClick={handleResendEmail}
        >{t`auth.btnResendEmail`}</ButtonResendEmail>
        <ButtonBackToLogin size="l" onClick={handleBackToLogin}>{t`auth.btnBackToLogin`}</ButtonBackToLogin>
      </ButtonsContainer>

      <Disclaimer>{fixHyphens(t`auth.formResetPassword.disclaimerNoEmail`)}</Disclaimer>
    </>
  );
};

export { ResetPasswordExpired };

const Message = styled.div.attrs({ className: 'text-center fs-14 mb-3' })``;
const ButtonsContainer = styled.form.attrs({ className: 'w-100 flex-grow-1' })``;
const ButtonResendEmail = styled(Button).attrs({ className: 'w-100 mt-3' })``;
const ButtonBackToLogin = styled(Button).attrs({ className: 'w-100 mt-3' })``;
const Disclaimer = styled.div.attrs({ className: 'my-4 mt-5 text-center text-gray fs-14' })``;
